/**
 * ET global helpers
 */
/* global Foundation jQuery */
var ET = (function($) {

  var api = {};

  /**
   * Generates a slug from string. E.g. lowercase, spaces converted to dashes, accent characters swapped, etc.
   *
   * @param {String} str - the text to slugify
   * @return {String} str - slugified text
   */
  api.slugify = function(str) {
    str = $.trim(str);
    str = str.toLowerCase();

    //Swap accents
    var from = 'åãàáäâẽèéëêìíïîõòóöôùúüûñç·/_,:;',
        to   = 'aaaaaaeeeeeiiiiooooouuuunc------';

    for (var i = 0, l = from.length; i < l; i++) {
      str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
    }

    str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
      .replace(/\s+/g, '-') // collapse whitespace and replace by -
      .replace(/-+/g, '-'); // collapse dashes

    str = str.substring(0,80); //Max 80 characters

    return str;
  };

  /**
   * Animates scrolling to specified element.
   *
   * Takes sticky header into account and adds padding for better whitespace
   *
   * @param {jQuery} element - element we want to scroll to (required)
   * @param {object} params - An object to pass parameters regarding animation (optional)
   * @param {function} callback - Callback function to execute after scrolling (optional)
   */
  api.scrollTo = function(element, params, callback) {
    var scrollableElement = $('html,body'),
        top = $(element).offset().top,
        stickyHeader = $('.site-header .stick.fixed'),
        stickyState = false,
        stickyPadding = 20, //20px for padding
        completeCalled = false;

    //Take sticky header height into account
    if(stickyHeader.length && top > stickyHeader.height()) {
      stickyState = true;
      top -= stickyHeader.height() + stickyPadding;
    }

    //Default params
    var defaults = {
      animate: true,
      duration: 200,
      easing: 'swing',
      complete: function() {
        if(!completeCalled) {
          var stickyHeader = $('.site-header .stick.fixed');
          //If header becomes sticky during scrolling, check position on complete
          if(!stickyState && stickyHeader.length && top > stickyHeader.height()) {
            top -= stickyHeader.height() + stickyPadding;
            scrollableElement.animate({scrollTop: top}, {animate: false, duration: 0});
          }

          if(typeof callback === 'function') {
            callback();
          }

          completeCalled = true; //Avoid double callback because we're animating $('html,body')
        }
      }
    };

    params = $.extend({}, defaults, params);

    if(!params.animate || (params.animate && navigator.userAgent.match(/IEMobile/i))) {
      //Mobile IE didn't animate well, so skip that even though animation is enabled

      scrollableElement.scrollTop(top);

      if(typeof params.complete === 'function') {
        params.complete();
      }

    }else {
      scrollableElement.animate({ scrollTop: top }, params);
    }
  };

  /**
   * Tests for foundation mediaqueries
   *
   * IMPORTANT: if you change default foundation media queries, be sure to register them with Foundation.utils.register_media
   * @see http://foundation.zurb.com/docs/javascript-utilities.html#media-queries
   *
   * @param {String} breakpoint - The breakpoint we are testing against (required)
   * @return {Boolean} match - Whether it is a match or not
   */
  api.isBreakpoint = function(breakpoint) {
    var match = false;

    if(matchMedia(Foundation.media_queries[breakpoint]).matches) {
      match = true;
    }

    return match;
  };

  /**
   * Lazyload jQuery plugin
   *
   * Returns JSON data to callback function, it is up to the callback function to place it on the page.
   * Requires the following data attributes to be present: ajax-url
   * Following options are optional: offset
   *
   * @sample $('.load-more').lazyload({callback: function(this, status, data) {}});
   * @return {jQuery}
   *
   */
  $.fn.lazyload = function(){

    //Extend the default options with given params
    var options = $.extend({
      callback: function() {}
    }, arguments[0] || {});


    return this.each(function(i, button) {

      //Define button
      var btn = $(button);

      //Bind click event
      btn.on('click', function(e, type) {
        e.preventDefault();

        //prevent filters from closing
        if(typeof type !== 'undefined' && type === 'ETtrigger') {
          e.stopPropagation();
        }

        //Dont' do anything if button is disabled
        if(btn.prop('disabled')) { return;}

        //Don't bother retrieving, if there are no more results
        if(btn.parent().is('.lazy-done')) { return; }

        var params = {
              offset: parseInt(btn.data('offset'), 10)
            },
            ajaxUrl = btn.data('ajaxUrl');

        //Set default offset
        if(isNaN(params.offset)) {
          params.offset = 0;
        }

        //Set button loading state
        btn.prop('disabled', true);
        btn.parent().addClass('lazy-loading');

        //TODO: implement loader gif of some sorts (maybe bind it to .lazy-loading class)

        //Do ajax request
        $.ajax({
          url: ajaxUrl,
          data: params,
          dataType: 'json',
          type: 'GET',
          success: function(data, textStatus, jqXHR) {

            //No more results
            if(data.items.length === 0 || !data.more) {
              btn.prop('disabled', true);
              btn.parent().addClass('lazy-done');
            }

            //Update offset
            btn.data('offset', params.offset + data.items.length);
            btn.attr('data-offset', params.offset + data.items.length);

            //Call the callback and apply the scope
            options.callback.call(btn, 'success', data);

          },
          error: function(jqXHR, textStatus, errorThrown) {

            //Call the callback and apply the scope
            options.callback.call(btn, 'error', []);

          },
          complete: function(jqXHR, textStatus) {
            //Remove button loading state
            if(!btn.parent().hasClass('.lazy-done')) {
              btn.prop('disabled', false);
            }
            btn.parent().removeClass('lazy-loading');

            //TODO: hide loader gif
          }
        });

      });
    });
  };

  api.supportsTouch = 'ontouchstart' in window || navigator.msMaxTouchPoints;

  return api;

})(window.jQuery);

export default ET;
